<template>
  <div class="iframe-container" :class="{ fullscreen: isFullscreen }">
    <button class="toggle-button" @click="toggleFullscreen">
      {{ isFullscreen ? "Quitter le plein écran" : "Plein écran" }}
    </button>

    <!-- Debug info en développement -->
    <!-- <div v-if="showDebug" class="debug-info">
      <p><strong>Test ID:</strong> {{ store.testData._id }}</p>
      <p><strong>URL iframe:</strong> {{ conditionalRunnerUrl }}</p>
      <p><strong>Docker mode:</strong> {{ isDocker }}</p>
      <p><strong>Base URL:</strong> {{ baseURL }}</p>
      <p><strong>Token:</strong> {{ tokenDebug }}</p>
    </div> -->

    <p v-if="!conditionalRunnerUrl">Chargement de l'aperçu du test conditionnel…</p>

    <iframe
      v-if="conditionalRunnerUrl"
      :src="conditionalRunnerUrl"
      frameborder="0"
      :class="{ fullscreen: isFullscreen }"
      @load="onIframeLoad"
      @error="onIframeError"
    ></iframe>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useTestStore } from '../../stores/testStore';

const store = useTestStore();

const tokenDebug = ref(localStorage.getItem('token') || '⚠️ aucun');

// Debug toggle (à supprimer en prod)
let showDebug = import.meta.env.DEV;
console.log("🔧 Conditional Debug mode:", showDebug);

const isDocker = import.meta.env.VITE_DOCKER_ON === "istrue";
const baseURL = import.meta.env.VITE_TRUNNER_URL;
console.log("🐳 Conditional Docker mode:", isDocker);

// URL Conditional Runner avec token preview
const conditionalRunnerUrl = computed(() => {
  if (!store.testData._id) {
    console.log("❌ Pas de testData._id disponible pour Conditional");
    return '';
  }

  // Vérifier que c'est bien un test Conditional
  if (store.testData.progression !== 'conditional') {
    console.log("⚠️ Ce test n'est pas conditionnel, progression:", store.testData.progression);
    return '';
  }

  const base = window.location.origin;
  const previewToken = generatePreviewToken(store.testData._id);

  let url;
  if (isDocker) {
    url = `${base}/testrunner/conditional-preview?testId=${store.testData._id}&previewToken=${previewToken}`;
  } else {
    url = `${baseURL}/conditional-preview?testId=${store.testData._id}&previewToken=${previewToken}`;
  }

  console.log("🔗 URL Conditional iframe générée:", url);
  return url;
});

// Fonction pour générer un token preview
function generatePreviewToken(testId) {
  const previewSecret = import.meta.env.VITE_PREVIEW_SECRET || 'preview-secret-waspl-2024';
  const payload = {
    mode: 'preview',
    testId: testId,
    timestamp: Date.now()
  };

  console.log("🔑 Génération token Conditional preview pour testId:", testId);
  const tokenContent = JSON.stringify(payload) + '::' + previewSecret;
  const token = btoa(tokenContent);
  console.log("✅ Token Conditional généré, longueur:", token.length);

  return token;
}

console.log("🔗 URL de l'iframe Conditional :", conditionalRunnerUrl.value);

// Observer les changements d'ID pour debug
watch(() => store.testData._id, (newTestID) => {
  console.log("🔄 ConditionalTestPreview - Nouveau test sélectionné :", newTestID);
});

watch(() => store.testData.progression, (newProgression) => {
  console.log("🔄 ConditionalTestPreview - Progression changée :", newProgression);
});

const isFullscreen = ref(false);

const toggleFullscreen = () => {
  isFullscreen.value = !isFullscreen.value;
};

// Gestion des événements iframe pour debug
const onIframeLoad = () => {
  console.log("✅ Iframe Conditional chargée avec succès");
};

const onIframeError = (event) => {
  console.error("❌ Erreur de chargement de l'iframe Conditional:", event);
};

watch(conditionalRunnerUrl, (newUrl) => {
  console.log("🚀 URL de l'iframe Conditional mise à jour :", newUrl);
});
</script>

<style scoped>
/* Conteneur principal */
.iframe-container {
  position: relative;
  width: 100%;
  height: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}

/* Plein écran */
.iframe-container.fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 1000;
}

/* Styles de l'iframe */
iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* Styles spécifiques au plein écran */
.iframe-container.fullscreen iframe {
  width: 100vw;
  height: 100vh;
}

/* Bouton de bascule */
.toggle-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
  padding: 8px 12px;
  background: #426C9C;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.toggle-button:hover {
  background: #36557c;
}

/* Debug info (à supprimer en prod) */
.debug-info {
  position: absolute;
  top: 50px;
  right: 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  z-index: 1001;
  max-width: 300px;
}
</style>
